import { InjectionToken } from '@angular/core';

export interface DatastoreFakeConfig {
  readonly initializeStoreState: boolean;
  readonly debug: boolean;
}

export const DATASTORE_FAKE_CONFIG = new InjectionToken<DatastoreFakeConfig>(
  'DatastoreFake Configuration',
);
